import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import { mainTable } from "../css/Common";
import FileUpload from "../ReusableComponents/FileUpload";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import GridPage from "../components/GridPage";
import { paymentInfoHeader } from "../components/HeaderAttribute";
import AddScreenTitle from "../components/AddScreenTitle";
import PaymentInfoPopup from "../popup-containers/PaymentInfoPopup";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { Flag } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import pdf from '../image/2025-ESG-Report.pdf'
const PaymentInfo = ({


}) => {
  const [paymentInfoFields, setPaymentInfoFields] = useState({
    mstPaymentInfoId: 0,
    paymentDate: new Date().toISOString().split("T")[0],
    paymentMethod: "",
    remarks: "",
    bank: "",
    bankBranch: "",
    amount: "",
    currency: "",
    referenceNumber: "",
    showImage: null,
  });
  const [paymentInfoFieldsError, setPaymentInfoFieldsError] = useState({
    paymentDateError: "",
    paymentMethodError: "",
    remarksError: "",
    bankError: "",
    bankBranchError: "",
    amountError: "",
    currencyError: "",
    referenceNumberError: "",
    showImageError: null,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [message, setMessage] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [imageSize, setImageSize] = useState(0);
  const [paymentMethodBindDD, setPaymentMethodBindDD] = useState([

  ]);

  const [currencyBindDD, setCurrencyBindDD] = useState([

  ]);

  const [bindPaymentInfoData, setBindPaymentInfoData] = useState([]);
  const [paymentInfoData, setPaymentInfoData] = useState({});
  const [fileClear, setFileClear] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const location1 = useLocation();
  const navigate = useNavigate();
  let issueAdd = location1?.state?.isAdd;
  const issueData = location1?.state?.isData;
  useEffect(() => {

    bindPaymentMethod();
  }, []);
  useEffect(() => {
    
    if (issueAdd) {
      setPaymentInfoFields({
        ...paymentInfoFields,
        mstPaymentInfoId: issueData.MstPaymentInfoId,
        paymentDate: issueData.UnformattedDate
          ? issueData.UnformattedDate.split("T")[0]
          : new Date().toISOString().split("T")[0],

        paymentMethod: issueData.PaymentMethodId ?? 1,
        remarks: issueData.Remarks,
        bank: issueData.Bank,
        bankBranch: issueData.BankBranch,
        amount: issueData.Amount,
        referenceNumber: issueData.ReferenceNumber,
        showImage: issueData.AttachmentFile,
        currency: issueData.Currency ?? 131,
      });
      console.log("issueAdd is true", issueData, paymentInfoFields);
      showAdd();
    }
  }, [issueAdd]);
  const bindPaymentMethod = async () => {
    
    try {
      setIsLoading(true);

      // Run two independent calls in parallel
      const [paymentMethodRes, systemSettingsRes] = await Promise.all([
        BindAPI("PaymentInfo/BindPaymentMethod"),
        BindAPI("SystemSettingsAPI/BindSystemSettings"),
      ]);

      // Format payment method dropdown
      const paymentMethods = paymentMethodRes?.data?.Table || [];
      setPaymentMethodBindDD(
        paymentMethods.map((item) => ({
          value: item?.PaymentMethodId,
          label: item?.PaymentMethod,
        }))
      );

      const currency = paymentMethodRes?.data?.Table1 || [];
      setCurrencyBindDD(
        currency.map((item) => ({
          value: item?.MstCurrencyId,
          label: item?.Code,
        }))
      );

      // Set image size from system settings
      const systemSettings = systemSettingsRes?.data?.Table || [];
      if (systemSettings.length > 0) {
        setImageSize(systemSettings[0]?.SizeForFileAttachment);
      }

      // Fetch payment info based on partner ID
      const clientId = sessionStorage.getItem("MstClientId");
      const payload = {
        mstClientId:
          clientId && clientId !== "null" ? parseInt(clientId, 10) : 0,
      };
      const paymentInfoRes = await BindPostAPI(
        payload,
        "PaymentInfo/BindPaymentInfo"
      );
      const paymentInfoData = paymentInfoRes?.data?.Table || [];

      setBindPaymentInfoData(paymentInfoData);

      // // Handle table visibility
      // if (paymentInfoData.length > 0 && paymentInfoData[0].Amount > 0) {
      //   setVisibleTable(true);
      //   setVisibleAdd(false);
      // } else if (
      //   paymentInfoData.length > 0 &&
      //   paymentInfoData[0].Amount == null
      // ) {
      //   setVisibleTable(true);
      //   setMessage(false);
      // } else {
      //   setVisibleTable(false);
      //   setMessage(true);
      // }
      

      if (paymentInfoData.length > 0) {
        const latestExpiry = paymentInfoData.reduce((max, item) => {
          return new Date(item.SubscriptionExpiryDate) > new Date(max)
            ? item.SubscriptionExpiryDate
            : max;
        }, paymentInfoData[0].SubscriptionExpiryDate);
      
        const expiry = new Date(latestExpiry);
        const today = new Date();
    
        if (expiry < today) {
          setVisibleTable(false);
          setVisibleAdd(false);
          setMessageType("expired");
          return;
        }
      
     
        const amount = paymentInfoData[0].Amount;
      
        if (!amount || amount <= 0) {
          setVisibleTable(false);
          setVisibleAdd(false);
          setMessageType("notPaid");
        } else {
         
          setVisibleTable(true);
          setVisibleAdd(false);
          setMessageType("");
        }
      
      } else {
        setVisibleTable(false);
        setMessageType("notPaid");
      }
    } catch (error) {
      console.error("Error fetching payment method data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const mstClientId = sessionStorage.getItem("MstClientId");


  const handleSubmit = async (items, flag) => {
    
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    const isFormError = {
      ...paymentInfoFieldsError,
      paymentMethodError: paymentInfoFields.paymentMethod
        ? ""
        : "Select Payment Method",
      remarksError: paymentInfoFields.remarks?.trim()
        ? ""
        : "Enter Proforma Invoice Number",
      bankError: paymentInfoFields.bank?.trim() ? "" : "Enter Bank",
      // bankBranchError: paymentInfoFields.bankBranch?.trim()
      //   ? ""
      //   : "Enter Bank Branch",
      amountError: paymentInfoFields.amount ? "" : "Enter Amount",
      currencyError: paymentInfoFields.currency > 0 ? "" : "Select currency",
      referenceNumberError: paymentInfoFields.referenceNumber?.trim()
        ? ""
        : "Enter Payment Reference Number",

      showImageError: paymentInfoFields.showImage
        ? ""
        : "Please select Payment Evidence to upload",
    };

    setPaymentInfoFieldsError(isFormError);

    const isFormValid = Object.values(isFormError).every(
      (error) => error === ""
    );

    if (isFormValid) {
      const payload = {
        MstPaymentInfoId: parseInt(paymentInfoFields.mstPaymentInfoId, 10),
        mstClientId: parseInt(mstClientId, 10),
        PaymentDate: paymentInfoFields.paymentDate,
        PaymentMethod: paymentInfoFields.paymentMethod,
        Remarks: paymentInfoFields.remarks,
        Bank: paymentInfoFields.bank,
        BankBranch: paymentInfoFields.bankBranch,
        Amount: paymentInfoFields.amount,
        Currency: paymentInfoFields.currency,
        ReferenceNumber: paymentInfoFields.referenceNumber,
        AttachmentFile: paymentInfoFields.showImage,
        CreatedBy: createdBy,
        Flag: flag,
      };

      const response = await IUDAPI(payload, "PaymentInfo/IUDPaymentInfo");
      if (flag === 1) {
        if (response.data.Table[0].Result === "S") {
          toast.success("Payment Info Added Successfully 👍", {
            duration: 4000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed To Add Payment Info 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag === 2) {
        if (response.data.Table[0].Result === "M") {
          toast.success("Payment Info Submitted Successfully 👍", {
            duration: 4000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed To Submitted Payment Info 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false);
      setIsOpen(true);
    }
  };
  const cancel = () => {
    setVisibleTable(true)
    navigate(".", {
      state: { ...location1.state, isAdd: false },
      replace: true,
    });
    setIsLoading(true);
    setPaymentInfoFields({
      paymentDate: new Date().toISOString().split("T")[0],
      paymentMethod: "",
      remarks: "",
      bank: "",
      bankBranch: "",
      amount: "",
      referenceNumber: "",
      showImage: null,
    });
    setPaymentInfoFieldsError({
      paymentDateError: "",
      paymentMethodError: "",
      remarksError: "",
      bankError: "",
      bankBranchError: "",
      amountError: "",
      referenceNumberError: "",
      showImageError: null,
    });
    setSubmitBtnDisabled(false);
    bindPaymentMethod();
    setpopUpOpen(false);
    setIsLoading(false);
    setVisibleAdd(false);
    setAddScreenTitle(false);
  };

  const handleShowImage = (showImage) => {

    const fileName = showImage.split("/").pop();

    const isDuplicate = bindPaymentInfoData.some(
      (item) => item.FileName === fileName
    );

    if (isDuplicate) {
      // Show error message if duplicate
      setPaymentInfoFieldsError({
        ...paymentInfoFieldsError,
        showImageError: `File name "${fileName}" already exists. Rename and try again.`,
      });
      setPaymentInfoFields({
        ...paymentInfoFields,
        showImage: "", // This will set to showImage if it's truthy, else ""
      });
      setFileClear(true);
    } else {
      setPaymentInfoFields({
        ...paymentInfoFields,
        showImage: showImage || "", // This will set to showImage if it's truthy, else ""
      });
    }
  };
  const showAdd = () => {

    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false); // Add Screen title & button
    setUpdateScreenTitle(true); // Update Screen title & button
  };
  const handleViewFile = (rowIndex, flag, file) => {
    
    if (file == 1) {
      const rowData = bindPaymentInfoData[rowIndex].ProformaInvoice;
      setSelectedFileUrl(rowData);
    } else if (file == 2) {
      const rowData = bindPaymentInfoData[rowIndex].TaxInvoice;
      setSelectedFileUrl(rowData);
    }

    setShowFileModal(true);
  };
  const isImageFile = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
    const ext = url?.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(ext);
  };
  const getViewerUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();

    return extension === "pdf"
      ? url
      : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        url
      )}`;
  };
  const handlePaymentInfo = (rowIndex, flag) => {
    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
    } else if (flag === 3) {
      setViewDetails(false);
    }

    const rowData = bindPaymentInfoData[rowIndex];

    setPaymentInfoData(rowData);
  };
  const handleEdit = async (rowIndex) => {

    setVisibleAdd(true);
    setAddScreenTitle(false);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex);
    const rowData = bindPaymentInfoData[rowIndex];
    setPaymentInfoFields({
      ...paymentInfoFields,
      mstPaymentInfoId: rowData.MstPaymentInfoId,
      paymentDate: rowData.UnformattedDate.split("T")[0],
      paymentMethod: rowData.PaymentMethodId,
      remarks: rowData.Remarks,
      bank: rowData.Bank,
      bankBranch: rowData.BankBranch,
      amount: rowData.Amount,
      referenceNumber: rowData.ReferenceNumber,
      showImage: rowData.AttachmentFile,
    });
  };
  const handlePartnerFieldsChange = (value, name) => {
    setPaymentInfoFields({
      ...paymentInfoFields,
      [name]: value,
    });
  };
  return (
    <MainLayout pageName={"4"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {/* {message && (
        <>
          <div class="my-1 max-lg:mt-4 mx-2 lg:mx-4 text-xl font-medium text-neutral-700">
            Payment Info
          </div>
          <div className="flex items-center justify-center h-[calc(100vh-12rem)] sm:min-h-[calc(100vh-9rem)]">
            <div className="border p-4 rounded-md shadow-sm max-w-md text-center">
              <div className="mb-2 text-sm text-red-500 italic space-y-2">
                <p>
                  Welcome aboard! Your registration on the Stay-Cool
                  Booking platform is now complete.
                </p>
                <p>
                  Your proforma invoice is getting ready and you will receive an
                  email notification once the proforma invoice is uploaded to
                  this portal. You may then make the payment accordingly and
                  update the payment details.
                </p>
              </div>
            </div>
          </div>
        </>
      )} */}

{messageType && (
  <>
    <div class="my-1 max-lg:mt-4 mx-2 lg:mx-4 text-xl font-medium text-neutral-700">
      Payment Info
    </div>

    <div className="flex items-center justify-center h-[calc(100vh-12rem)] sm:min-h-[calc(100vh-9rem)]">
      <div className="border p-4 rounded-md shadow-sm max-w-md text-center">

        {messageType === "notPaid" && (
          <div className="mb-2 text-sm text-red-500 italic space-y-2">
            <p>
                  Welcome aboard! Your registration on the Stay-Cool
                  Booking platform is now complete.
                </p>
                <p>
                  Your proforma invoice is getting ready and you will receive an
                  email notification once the proforma invoice is uploaded to
                  this portal. You may then make the payment accordingly and
                  update the payment details.
            </p>
          </div>
        )}

        {messageType === "expired" && (
          <div className="mb-2 text-sm text-red-500 italic space-y-2">
         <p>Your subscription has expired.</p>

<p>Please renew your subscription to continue using the platform.</p>

<p>
 
  please contact our support team or service provider.
</p>

<p>
  📞 Customer Support: +91-8754595873<br/>
  📧 Email: admin@stay-cool.in<br/>
  
</p>
          </div>
        )}

      </div>
    </div>
  </>
)}

      {visibleTable && !isLoading && (
        <GridPage
          title="Payment Info"
          header={paymentInfoHeader}
          addView={true}
          records={bindPaymentInfoData}
          blockView={true}
          onViewFile={handleViewFile}
          handleEdit={handleEdit}
          handleAction={handlePaymentInfo}
          showAdd={showAdd}
        />
      )}
      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={true}
              // updateScreenTitle={updateScreenTitle}
              title="Payment Info"
            />
            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div class={mainTable.grid2}>
                    <InputText
                      inputType="date"
                      title="Payment Date"
                      classStar="text-red-500"
                      name="date"
                      content={paymentInfoFields.paymentDate}
                      controlFunc={(e) =>
                        setPaymentInfoFields({
                          ...paymentInfoFields,
                          paymentDate: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setPaymentInfoFieldsError((paymentDateError) => ({
                          ...paymentDateError,
                          paymentDateError:
                            paymentInfoFields.paymentDate &&
                              !isNaN(
                                new Date(paymentInfoFields.paymentDate).getTime()
                              )
                              ? ""
                              : "Select Payment Date",
                        }));
                      }}
                      errorMessage={paymentInfoFieldsError.paymentDateError}
                    />
                    <div></div>
                    <div>
                      <DropDown
                        name="paymentMethod"
                        title="Payment Method"
                        classStar="text-red-500"
                        selectedOption={1}
                        options={paymentMethodBindDD}
                        controlFunc={(e) => {
                          setPaymentInfoFields({
                            ...paymentInfoFields,
                            paymentMethod: e.target.value,
                          });
                        }}
                        controlFuncBlur={(e) => {
                          const value = e.target.value;
                          setPaymentInfoFieldsError((prev) => ({
                            ...prev,
                            paymentMethodError: value
                              ? ""
                              : "Select Payment Method",
                          }));
                        }}
                        placeholder="Select Payment Method"
                        // tabIndex="1"
                        errorMessage={paymentInfoFieldsError.paymentMethodError}
                      />
                      {/* {paymentInfoFieldsError && (
                        <span className="text-red-500 text-sm font-medium">
                          {paymentInfoFieldsError.paymentMethodError}
                        </span>
                      )} */}
                    </div>
                    <InputText
                      inputType="text"
                      title="Payment Reference Number"
                      name="referenceNumber"
                      content={paymentInfoFields.referenceNumber}
                      maxLength={50}
                      classStar="text-red-500"
                      controlFunc={(e) => {
                        const inputVal = e.target.value;
                        const onlyLettersRegex = /^[0-9A-Za-z-/\s]*$/; // Allow letters, space, hyphen, slash
                        if (onlyLettersRegex.test(inputVal)) {
                          setPaymentInfoFields({
                            ...paymentInfoFields,
                            referenceNumber: e.target.value,
                          });
                        }
                      }}
                      controlFuncBlur={() => {
                        const trimmedRef =
                          paymentInfoFields.referenceNumber?.trim() || "";
                        setPaymentInfoFieldsError(() => ({
                          ...paymentInfoFieldsError,
                          referenceNumberError: trimmedRef
                            ? ""
                            : "Enter Payment Reference Number",
                        }));
                      }}
                      errorMessage={paymentInfoFieldsError.referenceNumberError}
                    />

                    <InputText
                      inputType="text"
                      title="Bank"
                      name="bank"
                      content={paymentInfoFields.bank}
                      maxLength={100}
                      classStar="text-red-500"
                      controlFunc={(e) => {
                        {
                          const inputVal = e.target.value;
                          const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                          if (onlyLettersRegex.test(inputVal)) {
                            setPaymentInfoFields({
                              ...paymentInfoFields,
                              bank: e.target.value,
                            });
                          }
                        }
                      }}
                      controlFuncBlur={() => {
                        const trimmedBank =
                          paymentInfoFields.bank?.trim() || "";
                        setPaymentInfoFieldsError(() => ({
                          ...paymentInfoFieldsError,
                          bankError: trimmedBank ? "" : "Enter Bank",
                        }));
                      }}
                      errorMessage={paymentInfoFieldsError.bankError}
                    />

                    <InputText
                      inputType="text"
                      title="Bank Branch"
                      name="bankBranch"
                      content={paymentInfoFields.bankBranch}
                      maxLength={100}
                      // classStar="text-red-500"
                      controlFunc={(e) => {
                        // {
                        // const inputVal = e.target.value;
                        // const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                        // if (onlyLettersRegex.test(inputVal)) {
                        setPaymentInfoFields({
                          ...paymentInfoFields,
                          bankBranch: e.target.value,
                        });
                        // }
                        // }
                      }}
                    // controlFuncBlur={() => {
                    //   const trimmedBankBranch =
                    //     paymentInfoFields.bankBranch?.trim() || "";
                    //   setPaymentInfoFieldsError(() => ({
                    //     ...paymentInfoFieldsError,
                    //     bankBranchError: trimmedBankBranch
                    //       ? ""
                    //       : "Enter Bank Branch",
                    //   }));
                    // }}
                    // errorMessage={paymentInfoFieldsError.bankBranchError}
                    />
                    <AutoDropDown
                      title="Currency"
                      options={currencyBindDD}
                      placeholder="Select"
                      name="currency"
                      selectedOption={currencyBindDD.find(
                        (x) => x.value == 131
                      )}
                      Class="custom-class"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handlePartnerFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setPaymentInfoFieldsError(() => ({
                          ...paymentInfoFieldsError,
                          currencyError: paymentInfoFields.currency
                            ? ""
                            : "Select currency",
                        }));
                      }}
                      errorMessage={paymentInfoFieldsError.currencyError}
                    />
                    <InputText
                      inputType="text"
                      title="Amount"
                      name="amount"
                      content={paymentInfoFields.amount}
                      maxLength={13}
                      classStar="text-red-500"
                      controlFunc={(e) => {
                        // Allow only numbers and optional one decimal point
                        if (/^\d*\.?\d*$/.test(e.target.value)) {
                          setPaymentInfoFields({
                            ...paymentInfoFields,
                            amount: e.target.value,
                          });
                        }
                      }}
                      controlFuncBlur={() => {
                        setPaymentInfoFieldsError(() => ({
                          ...paymentInfoFieldsError,
                          amountError: paymentInfoFields.amount
                            ? ""
                            : "Enter Amount",
                        }));
                      }}
                      errorMessage={paymentInfoFieldsError.amountError}
                    />

                    <InputText
                      inputType="text"
                      title="Proforma Invoice Number"
                      name="remarks"
                      content={paymentInfoFields.remarks}
                      maxLength={500}
                      classStar="text-red-500"
                      controlFunc={(e) => {
                        setPaymentInfoFields({
                          ...paymentInfoFields,
                          remarks: e.target.value,
                        });
                      }}
                      controlFuncBlur={() => {
                        const trimmedRemarks =
                          paymentInfoFields.remarks?.trim() || "";
                        setPaymentInfoFieldsError(() => ({
                          ...paymentInfoFieldsError,
                          remarksError: trimmedRemarks
                            ? ""
                            : "Enter Proforma Invoice Number",
                        }));
                      }}
                      errorMessage={paymentInfoFieldsError.remarksError}
                    />
                  </div>
                  <FileUpload
                    title="Payment Evidence"
                    apiCall="PaymentInfo/FileUpload"
                    modalName="PaymentInfoUpload"
                    mstClientId={mstClientId}
                    clear={fileClear}
                    disabledBtn={updateScreenTitle}
                    name="showImage"
                    classStar="text-red-500"
                    showImage={paymentInfoFields.showImage}
                    showImageData={handleShowImage}
                    imageUploadedError={paymentInfoFieldsError.showImageError}
                    clearImageUploadError={() =>
                      setPaymentInfoFieldsError((prev) => ({
                        ...prev,
                        showImageError: "",
                      }))
                    }
                    limitMassage={`Image size limit: ${imageSize} MB. Accepted Image types: jpg, png, jpeg. Please Upload The Image After Choosing It.`}
                    imageShow={false}
                    MAX_FILE_SIZE_MB={imageSize}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  />
                </form>

                <Buttons
                  viewSaveButton={true}
                  //  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)} // Outside click closes modal
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            {selectedFileUrl ? (
              isImageFile(selectedFileUrl) ? (
                <img
                  src={selectedFileUrl}
                  alt="Preview"
                  className="w-full h-full object-contain rounded"
                />
              ) : (
                <iframe
                  src={getViewerUrl(selectedFileUrl)}
                  title="File Viewer"
                  className="w-full h-[80vh] rounded"
                />
              )
            ) : (
              <div className="text-center text-gray-500">No file selected</div>
            )}
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Payment Info"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
          />

          <PaymentInfoPopup
            data={paymentInfoData}
            data1={paymentMethodBindDD}
            isLoading={isLoading}
          />
        </div>
        <PopUpButtons cancel={cancel} />
      </MainPopup>
    </MainLayout>
  );
};


export default PaymentInfo;
